import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import {
  LastSelectionHeaderComponent
} from '@ux/components/last-selection-header/last-selection-header.component';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';

@NgModule({
  declarations: [
    LastSelectionHeaderComponent
  ],
  imports: [
    CommonModule,
    GlobalPipesModule,
    TranslocoModule,
    IconDsComponent,
    TypographyDsComponent,
  ],
  exports: [
    LastSelectionHeaderComponent
  ]
})
export class LastSelectionModule { }
